import { Component, computed, effect, inject, input, OnInit, signal, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatRow, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FilterState } from '../../../interfaces/generatorsmodel';
import { FieldConfiguration, GetToterPriceMatrixByIdResponse, PriceMatrixList, TotePmGridColumns, TotePriceMatrix, ToteRentalType, ToterPriceMatrix } from '../../../interfaces/pricematrixmodel';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { FeedstockService } from '../../../services/feedstockservice';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { AddeditTotepricematrixComponent } from './addedit-totepricematrix/addedit-totepricematrix.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationService } from '../../../services/notificationservice';
import { RolePermissionsService } from '../../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../interfaces/securityPermissions';
import { RoleService } from '../../../services/role.service';

@Component({
  selector: 'app-totepricematrix',
  imports: [
    CommonModule,
    MatTableModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatRow,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMenuModule,
    MatProgressBarModule
  ],
  templateUrl: './totepricematrix.component.html',
  styleUrl: './totepricematrix.component.scss'
})
export class TotepricematrixComponent implements OnInit {
  permissions = inject(RolePermissionsService);
  dynamicColumns = signal<TotePmGridColumns[]>([]);

  dataSource = new MatTableDataSource<any>;
  loadTPMList: TotePriceMatrix[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
  genid = 0;
  streamid = 0;
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  displayedColumns = computed(() => {
    const cols = this.dynamicColumns().map(col => col.columnDef);
    return ['actions', ...cols];
  });
  private _lastGenId: string = '__UNSET__';
  private _lastStreamId: string = '__UNSET__';
  private _lastTrigger: number = -1;

  constructor(private _dialog: MatDialog, private fsService: FeedstockService,
    private datePipe: DatePipe, private notificationService: NotificationService,
    private rolesService: RoleService) {
    effect(() => {
      const trigger = this.refreshTrigger();
      const currentFilter = this.filterState();
      console.log("tpm refresh trigger", trigger);
      if (!currentFilter || currentFilter.tabIndex !== 3) return;
      const genId = currentFilter?.generator?.toString() || '0';
      const streamId = currentFilter?.stream?.toString() || '0';

      const isForceRefresh = this._lastTrigger !== trigger;
      const hasFilterChanged = this._lastGenId !== genId || this._lastStreamId !== streamId;


      this._lastGenId = genId;
      this._lastStreamId = streamId;
      this._lastTrigger = trigger;

      if (genId === '0' || genId === 'null' || streamId === '0' || streamId === 'null') {
        this.dataSource.data = [];
        return;
      }
      this.genid    = parseInt(genId);
      this.streamid = parseInt(streamId);

      this.loadFieldConfigurations();
      // if (trigger > 0) {
      //   const streamid = this.filterState()?.stream?.toString() || '0';
      //   const genId = this.filterState()?.generator?.toString() || '0';
      //   this.genid = parseInt(genId);
      //   this.streamid = parseInt(streamid);
      //   this.loadFieldConfigurations();
      // } else {
      //   this.genid = 0;
      //   this.streamid = 0;
      //   this.loadFieldConfigurations();
      // }
    });

    effect(() => {
      const searchText = this.gridSearchText();
      if (this.dataSource) {
        console.log(`TPM Component: Applying filter for search text: ${searchText}`);
        this.applyGridFilter(searchText ?? '');
      }
    });
  }

  ngOnInit(): void {
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
  }

  loadFieldConfigurations(): void {
    this.fsService.getTPMFieldConfig(this.genid).subscribe({
      next: (res: FieldConfiguration[]) => {
        console.log("tpm config data", res, "for customer id", this.genid);
        const dynamicCols: TotePmGridColumns[] = (res || [])
          .filter(config => config.visible)
          .map(config => ({
            columnDef: this.standardizeDataKey(config.fieldName),
            header: config.label,
            visible: config.visible
          }));

        this.dynamicColumns.set(dynamicCols);

        this.getTotePriceMatrixDetails(this.genid, this.streamid);

        const currentSearchText = this.gridSearchText();
        if (currentSearchText) {
          this.applyGridFilter(currentSearchText);
        }
      }
    });
  }

  getTotePriceMatrixDetails(genid: number, streamid: number): void {
    if (streamid === 0) {
      return;
    }
    this.fsService.getTotePriceMatrixList(genid, streamid).subscribe({
      next: (res: TotePriceMatrix[]) => {
        console.log("tpm grid data", res);
        const dataArray = Array.isArray(res) ? res : [];

        const transformedData = dataArray.map(item => this.transformToPascalCase<TotePriceMatrix>(item));

        console.log("tpm grid T data", transformedData);

        this.loadTPMList = transformedData;
        this.dataSource = new MatTableDataSource(this.loadTPMList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        const currentSearchText = this.gridSearchText();
        if (currentSearchText) {
          this.applyGridFilter(currentSearchText);
        }
      }
    });
  }

  getToteRentalTypes(id: number): void {
  }

  applyGridFilter(filterText: string) {
    console.log("TPM grid search fired");
    const filterValue = filterText.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onOpenPM(row: TotePriceMatrix, task: string): void {
    this.fsService.getToteRentalTypes(row.Id).subscribe({
      next: (res: GetToterPriceMatrixByIdResponse) => {
        console.log("Tote Rental Types fetched for PM open:", res);

        const detail = res.toterPriceMatrix;
        const rentals = res.toteRentalType || [];

        row.FuelSurcharge          = detail.fuelSurcharge          ?? null;
        row.ExtraPickup            = detail.extraPickup             ?? null;
        row.MonthlyCharges         = detail.monthlyCharges          ?? null;
        row.EIS                    = detail.eis                     ?? null;
        row.LockBeforeDelivery     = detail.lockBeforeDelivery      ?? null;
        row.LockAfterDelivery      = detail.lockAfterDelivery       ?? null;
        row.ToteReplacement        = detail.toteReplacement         ?? null;
        row.RemovalRedeliveryFee   = detail.removalRedeliveryFee    ?? null;
        row.RelocationFee          = detail.relocationFee           ?? null;
        row.StartupFee             = detail.startupFee              ?? null;
        row.AdditionalPickupFeeForSite = detail.additionalPickupFeeForSite ?? null;
        
        row.PerPickupFee           = detail.perPickupFee            ?? null;
        row.ContaminationFee       = detail.contaminationFee        ?? null;
        row.EmergencyPickupFee     = detail.emergencyPickupFee      ?? null;
        row.LeakingBin             = detail.leakingBin              ?? null;
        row.DamagedBin             = detail.damagedBin              ?? null;
        row.LandfillHaul           = detail.landfillHaul            ?? null;
        row.NewKey                 = detail.newKey                  ?? null;

        
        //row.Effective_StartDate    = detail.effective_StartDate     ?? null;
        //row.Effective_EndDate      = detail.effective_EndDate       ?? null;


        const genId = this.filterState()?.generator?.toString() || '0';
        let rentalTypesData = rentals || [];
        if (task == 'Duplicate') {
          row.Id = 0;
          rentalTypesData = rentalTypesData.map(rt => ({
            ...rt,
            id: 0,
            priceMatrixId: 0
          }));
        }
        row.ToteRentalTypes = rentalTypesData;
        const dialogRef = this._dialog.open(AddeditTotepricematrixComponent, {
          data: {
            pmInputData: row,
            streamId: this.filterState()?.stream || 0,
            genId: parseInt(genId),
            task: task,
            canSave: this.controlPermissions.editTotePriceMatrix,
            showAddButton: true,
            showGridEditButton: true,
            showGridDeleteButton: this.controlPermissions.deleteTotePriceMatrix
          },
          disableClose: true,
          width: '1000px',
          maxWidth: '1050px',
          maxHeight: '90vh'
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const genId = this.filterState()?.generator?.toString() || '0';
            const streamid = this.filterState()?.stream?.toString() || '0';
            this.genid = parseInt(genId);
            this.streamid = parseInt(streamid);
            this.loadFieldConfigurations();
            this.notificationService.show(`Tote Price Matrix saved successfully`, 'Success');
          }
        });
      },
    });
  }

  onDeletePM(id: number) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Tote Price Matrix ${id}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {
          const genId = this.filterState()?.generator?.toString() || '0';
          this.fsService.deleteTotePriceMatrix(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.Id !== id);
              this.notificationService.show(`Tote Price Matrix deleted successfully`, 'Success');
            }
          });
        }
      }
    });
  }

  isNumeric(value: string): boolean {
    return value !== null && value.trim() !== '' && !isNaN(Number(value));
  }

  isNumericFilterMatch(data: TotePriceMatrix, filterValue: number): boolean {
    const numericFields: Array<keyof TotePriceMatrix> = [
      'EIS', 'FuelSurcharge', 'ExtraPickup', 'MonthlyCharges'
    ];
    for (const field of numericFields) {
      const value = data[field];
      if (typeof value === 'number' && value === filterValue) {
        return true;
      }
    }
    return false;
  }

  formatCell(value: any, columnDef: string): string {
    if (value === null || value === undefined) return '';

    if (['SelfHaul', 'AllSites', 'InvoiceNA'].includes(columnDef)) {
      return value ? 'Yes' : 'No';
    }

    if (columnDef.includes('Effective_')) {
      return this.datePipe.transform(value, 'MM/dd/yyyy') ?? String(value);
    }
    return String(value);
  }

  transformToPascalCase<T>(data: any): T {
    const transformed: any = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
        transformed[pascalKey] = data[key];
      }
    }
    if (transformed['Eis'] !== undefined) {
      transformed['EIS'] = transformed['Eis'];
      delete transformed['Eis'];
    }
    return transformed as T;
  }

  private standardizeDataKey(key: string): string {
    if (!key) return '';
    let pascalKey = key.charAt(0).toUpperCase() + key.slice(1);

    if (pascalKey === 'Eis') {
      return 'EIS'; // Return the all-caps version
    }
    return pascalKey;
  }
}
